import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'

import { formatDate } from '@atheneum/api/dist/lib'

import NoContent from '@components/Error/NoContent'
import DownloadIcon from '@components/Icon/Download'
import ScreeningIcon from '@components/Icon/Screening'
import Star from '@components/Icon/Star'

import './Table.sass'

class Table extends Component {
  static propTypes = {
    sidebarStore: PropTypes.object,
    historyStore: PropTypes.object,
    modalStore: PropTypes.object,
    staticData: PropTypes.object
  }

  handleClick = (e, id) => {
    e.stopPropagation()
    this.props.sidebarStore.openSidebar({
      template: 'project',
      id: id
    })
  }

  renderTableRows = () => {
    return this.props.historyStore.projects.rows.map((row, index) => {
      let pcfRecivedDate = ''
      let rating = ''
      let fee = null
      let feeCurrencyId = null
      let cpdStatusId = null
      let cpdDate = null
      let downloadId = getExpertInvoiceDownloadId(
        this.props.staticData,
        row.consultationPaymentDetails
      )

      if (row.expertFeedbacks.length > 0) {
        rating = row.expertFeedbacks[0].averageRating
      }
      if (row.consultationPaymentDetails.length > 0) {
        pcfRecivedDate = row.consultationPaymentDetails[0].datePCF
        cpdStatusId = row.consultationPaymentDetails[0].paymentStatusId
        cpdDate = row.consultationPaymentDetails[0].paymentDate
      }
      if (row.feeEntry && row.feeEntry.feeItems.length > 0) {
        fee = row.feeEntry.feeItems[0].value
        feeCurrencyId = row.feeEntry.feeItems[0].currencyId
      }

      return (
        <tr
          className='clickable-row'
          key={index}
          onClick={e => this.handleClick(e, row.project.id)}
        >
          <td>
            <span className='title' onClick={e => e.stopPropagation()}>
              <Link to={`/project/${row.projectId}/experts-pipeline/${row.id}`}>
                {row.project.projectName}
              </Link>
              <span className='desc desc--top-spacing'>
                {formatDate(row.project.startDate)} -{' '}
                {row.project.endDate
                  ? formatDate(row.project.endDate)
                  : 'Current'}
              </span>
            </span>
          </td>
          <td>
            {this.props.staticData.getDataFromArray(
              row.eplStatusId,
              'eplStatuses'
            ) || '-'}
            <span className='desc'>
              {this.props.staticData.getDataFromArray(
                row.eplStatusCommentId,
                'eplStatusComments'
              )}
            </span>
          </td>
          <td>
            {this.props.staticData.getDataFromArray(
              row.replyStatusId,
              'replyStatuses'
            ) || '-'}
            <span className='desc'>
              {this.props.staticData.getDataFromArray(
                row.replyStatusCommentId,
                'replyStatusComments'
              )}
            </span>
          </td>
          <td>
            {row.screeningQuestions.length || row.screening ? (
              <div
                className='expert-form--center'
                onClick={e => {
                  e.stopPropagation()
                  this.props.modalStore.show({
                    type: 'SCREENING_QUESTIONS',
                    props: {
                      screeningQuestions: row.screeningQuestions,
                      screening: row.screening
                    }
                  })
                }}
              >
                <ScreeningIcon className='icon__fill icon__fill--orange' />
                {row.match && <span className='tab__bullet'>&bull; </span>}
              </div>
            ) : (
              <div className='expert-form--center'>-</div>
            )}
          </td>
          <td>{formatDate(row.dateInterviewed) || '-'}</td>
          <td>{row.interviewDuration ? `${row.interviewDuration}min` : '-'}</td>
          <td>{formatDate(pcfRecivedDate) || '-'}</td>
          <td>
            {this.renderCurrency(fee, feeCurrencyId, 'currencies') || '-'}
          </td>
          <td>
            {this.props.staticData.getDataFromArray(
              cpdStatusId,
              'paymentStatuses'
            ) || '-'}
            <span className='desc'>{formatDate(cpdDate)}</span>
          </td>
          <td>{this.renderDownloadButton(downloadId) || '-'}</td>
          <td>
            {rating ? this.renderRating(rating, row.expertId, row.id) : '-'}
          </td>
        </tr>
      )
    })
  }

  renderDownloadButton = downloadId => {
    if (!downloadId) return null

    const token = localStorage.getItem('ngStorage-accessToken')

    return (
      <a
        onClick={e => e.stopPropagation()}
        href={
          '/api/consultation-payment-detail/' +
          downloadId +
          '/invoice-export?token=' +
          token
        }
        target='_blank'
        download rel="noreferrer"
      >
        <DownloadIcon className='download' />
      </a>
    )
  }

  renderRating = (rating, expertId, eplId) => {
    return (
      <div
        className='flex-center clickable'
        onClick={e => {
          e.stopPropagation()
          this.props.historyStore
            .getFeedbacks(expertId, eplId)
            .then(() => this.showExpertFeedbacks())
        }}
      >
        <Star />
        <span>{rating}</span>
      </div>
    )
  }

  showExpertFeedbacks = () => {
    const { modalStore, historyStore } = this.props
    const feedbacks = historyStore.feedbacks

    return modalStore.show({
      type: 'EXPERT_FEEDBACK',
      props: {
        feedbacks
      }
    })
  }

  renderCurrency = (honorarium, currencyId, array) => {
    if (!honorarium || !currencyId || !array) return ''
    const currency = this.props.staticData.getDataFromArray(currencyId, array)
    return honorarium + ' ' + currency
  }

  render () {
    const { projects } = this.props.historyStore
    if (!projects || projects.count < 1) {
      return <NoContent label='No projects to show' />
    }

    return (
      <table className='table-wrapper expert-history'>
        <tbody>
          <tr className='title'>
            <th>Project name</th>
            <th>Status</th>
            <th>Reply status</th>
            <th>Screening</th>
            <th>Consultation</th>
            <th>Interview duration</th>
            <th>PCF received</th>
            <th>Honorarium</th>
            <th>Payment status</th>
            <th>Invoice</th>
            <th>Feedback</th>
          </tr>
          {this.renderTableRows()}
        </tbody>
      </table>
    )
  }
}

export default withRouter(
  inject(
    'historyStore',
    'staticData',
    'sidebarStore',
    'modalStore'
  )(observer(Table))
)

/**
 * For some reason CPDs are returned as an array.
 * Maybe because it's possible to have multiple EPLs (and then fees) on a project,
 * or maybe it's just the result from a left join when the data is being fetched.
 *
 * To make sure that the user can download an invoice we have to check it has
 * all the required data like payment transfer method and a PAID status.
 */
function getExpertInvoiceDownloadId (staticData, cpds = []) {
  const PAID = staticData.CONST.PAYMENT_STATUSES.PAID

  const cpd = cpds.find(cpd => {
    return cpd.paymentTransferMethodId && cpd.paymentStatusId === PAID
  })

  return cpd ? cpd.id : null
}
